import { connect } from 'react-redux';
import actions from '../redux/actions/order_transaction_history';
import OrderTransactionHistory from '../component/order-transaction-history/OrderTransactionHistory';

const mapStateToProps = (state) => ({
  orderTrans: state.orderTrans,
  coinSettings: state.setting.coinSettings,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchFilterTransactionHistoryAction: (params, callback) => {
    dispatch(actions.fetchFilterTransactionHistoryAction(params, callback));
  },
  searchOrderTransByIDAction: (params, callback = () => {}) => {
    dispatch(actions.searchOrderTransByIDAction(params, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderTransactionHistory);
